import { Divider } from "PFComponents/divider";
import {
  ExperienceCommonProps,
  ParentChildCommonProps
} from "PFComponents/experience_level/experience_level.types";
import { Experience } from "PFTypes";

import css from "./experience_level_tooltip_content.module.scss";
import { ProfileExperienceTooltipContent } from "./parts/profile_experience_tooltip_content";
import { RequiredExperienceTooltipContent } from "./parts/required_experience_tooltip_content";

type ExperienceLevelTooltipContentRequiredProps = {
  experience?: Experience | null;
  requiredExperience: Experience;
} & ExperienceCommonProps &
  ParentChildCommonProps;

export const ExperienceLevelTooltipContentRequired = ({
  experience,
  requiredExperience,
  hasParentValues,
  hasChildValues,
  experienceLevels,
  experienceLabelMap
}: ExperienceLevelTooltipContentRequiredProps) => (
  <div className={css.requiredExperience}>
    <RequiredExperienceTooltipContent
      experienceLevels={experienceLevels}
      experienceLabelMap={experienceLabelMap}
      requiredExperience={requiredExperience}
    />
    <Divider className={css.divider} type="vertical" color="paletteBlue2" />
    <ProfileExperienceTooltipContent
      experienceLevels={experienceLevels}
      experienceLabelMap={experienceLabelMap}
      experience={experience}
      hasParentValues={hasParentValues}
      hasChildValues={hasChildValues}
    />
  </div>
);
